// extracted by mini-css-extract-plugin
module.exports = {"animatedBarWrap":"pageHeaderLoader_animatedBarWrap__BD5Gr","animatedBarLoader":"pageHeaderLoader_animatedBarLoader__p1fby"};